// Frontend app version — shown in the desktop footer + the mobile login footer.
// Bump on each "שמור גרסה" in lock-step with package.json "version" and the backend
// config/params.php 'appVersion'.
export const APP_VERSION = "2.2.2";
